const FILESTACK_DEFAULT_OPTIONS = {
  maxFiles: 1,
  storeTo: {
    location: "s3",
  },
  accept: [".pdf", "text/*", "image/*", "video/*"],
};

// eslint-disable-next-line prefer-destructuring
export const FILESTACK_API_KEY = window.HA_CONF.FILEPICKER.API_KEY;

export const filestackOptions = (options) => {
  return { ...FILESTACK_DEFAULT_OPTIONS, ...options };
};
